module.exports = __webpack_public_path__ + "quotezone-ui/img/rim-black.60d70e76.gif";